import { LegalPage } from "../../components/LegalPage";

export function Cookies() {
  return (
    <LegalPage
      title="Cookie Policy"
      description="WeConsult Rx cookie policy: we use only essential cookies. No third-party advertising trackers. How to manage your preferences."
      path="/cookies"
      effective="2026-05-30"
    >
      <p>
        WeConsult Rx uses only the minimum cookies required to make
        weconsultrx.com work. We do not run third-party analytics or
        advertising trackers on the marketing site.
      </p>

      <h2>What we use</h2>
      <h3>Essential cookies / local storage</h3>
      <ul>
        <li>
          <code>wcrx_cookie_choice_v1</code> — your cookie banner choice. Stored
          in localStorage (not a cookie). Lifetime: until cleared.
        </li>
      </ul>

      <h3>Authentication (app.weconsultrx.com)</h3>
      <p>
        The authenticated application uses session tokens stored locally and a
        service worker for offline shell caching.
      </p>

      <h2>What we don’t use</h2>
      <ul>
        <li>No Google Analytics on this marketing site.</li>
        <li>No Facebook Pixel or other social trackers.</li>
        <li>No third-party advertising cookies.</li>
        <li>No session replay tools.</li>
      </ul>

      <h2>Your choices</h2>
      <p>
        You may clear your browser’s storage at any time. The cookie banner
        will reappear on your next visit and you can re-select your preference.
      </p>

      <h2>Contact</h2>
      <p>privacy@weconsultrx.com</p>
    </LegalPage>
  );
}
